import React from 'react';

class WhyUs extends React.Component {
  render() {
    return (
      <div id="whyus" className="section-padding">
        <div className="overlay"></div>
        <div className="container">
          <div className="section-header text-center">
            <h2 className="section-title wow fadeInDown animated text-white" data-wow-delay="0.3s">Why to choose appXcube</h2>
          </div>
          <div className="row justify-content-between">
            <div className="col-lg-12 col-md-12 col-xs-12">
              <div className="row">

                <div className="col-lg-3 col-md-6 col-xs-12">
                  <div className="counter-box wow fadeInUp animated">
                    <div className="icon-o"><i className="lni-user"></i></div>
                    <div className="fact-count">
                      <h3>User-Oriented Approach</h3>
                    </div>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-xs-12">
                  <div className="counter-box wow fadeInUp animated" >
                    <div className="icon-o"><i className="lni-emoji-smile"></i></div>
                    <div className="fact-count">
                      <h3>Efficient Project Management</h3>

                    </div>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-xs-12">
                  <div className="counter-box wow fadeInUp animated">
                    <div className="icon-o"><i className="lni-thumbs-up"></i></div>
                    <div className="fact-count">
                      <h3>Flexi & Scalable Pricing</h3>
                    </div>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-xs-12">
                  <div className="counter-box wow fadeInUp animated">
                    <div className="icon-o"><i className="lni-rocket"></i></div>
                    <div className="fact-count">
                      <h3>Growth and Optimization</h3>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default WhyUs;


// WEBPACK FOOTER //
// ./src/sections/WhyUs.js